import { render } from "./LC.vue?vue&type=template&id=72b50326"
import script from "./LC.vue?vue&type=script&lang=js"
export * from "./LC.vue?vue&type=script&lang=js"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__